module.exports = __webpack_public_path__ + "img/emrota-sempedidos.7cb3e449.png";